import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { style: { "display": "flex", "flex-direction": "column", "align-items": "center", "justify-content": "start", "font-size": "1.1rem" } };
const _hoisted_2 = { class: "mb-4 mt-4" };
const _hoisted_3 = { class: "mb-4" };
const _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        title: _ctx.title,
        "show-header": _ctx.hasTitle
    }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: "Ja",
                onClick: _ctx.onSuccess,
                "button-style": "btn-success",
                class: "w-120-px"
            }, null, 8, ["onClick"]),
            _createVNode(_component_g_button, {
                text: "Nein",
                onClick: _ctx.onCancel,
                "button-style": "btn-danger",
                class: "w-120-px"
            }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_g_icon, {
                        width: "72",
                        height: "72",
                        src: "/assets/icons/question-square.svg"
                    })
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", { innerHTML: _ctx.message }, null, 8, _hoisted_4)
                ])
            ])
        ]),
        _: 1
    }, 8, ["title", "show-header"]));
}
